import type { AlarmStatus } from '@empower-safety/shared-types';
import { cn } from '../lib/cn.js';

// AlarmStatus → design-system pill class. Mirrors the .pill base + .pill-* variants
// from the global stylesheet so alarms / visits / journeys / broadcasts all share
// one visual language for status badges.

const labels: Record<AlarmStatus, string> = {
  active: 'Active',
  acknowledged: 'Acknowledged',
  resolved: 'Resolved',
  false_alarm: 'False alarm',
};

const variants: Record<AlarmStatus, string> = {
  active: 'pill-active',
  acknowledged: 'pill-acknowledged',
  resolved: 'pill-resolved',
  false_alarm: 'pill-neutral',
};

export function StatusPill({ status, className }: { status: AlarmStatus; className?: string }) {
  return <span className={cn('pill', variants[status], className)}>{labels[status]}</span>;
}
